import React from 'react';
import { useNavigate } from 'react-router-dom';

export const SidebarBrand = () => {

    const navigate = useNavigate();

    const handleGoHome = () => {
        navigate('/');
    };

    return (
        <div className="m-header">
            <button type="button" className="b-brand border-0 bg-transparent p-0" onClick={handleGoHome} style={{ cursor: 'pointer' }}>
                <img src="/assets/logo/logo-full.png" alt="logo" className="logo logo-lg" />
                <img src="/assets/logo/logo-abbr.png" alt="logo" className="logo logo-sm" />
            </button>
        </div>
    )

};
